<template>
    <div>
        <div v-if="pagination_section" class="row justify-content-between align-items-end mb-2">
            <div class="col-12 justify-content-end col-md-4 mb-1 col-lg-4 d-flex align-items-center">
                <small class="mr-2">Per page:</small>
                <multiselect v-model="table_info.per_page" :options="[10, 25, 50, 100]" @select="changePerPage" :allow-empty="false" :show-labels="false"></multiselect>
            </div>
		</div>

        <div>
         <table class="table table-bordered">
            <thead>
                <tr>
                    <th class="green-content"  v-for="(item, key) in table_headers" :key="key">{{item}}</th>
                </tr>
            </thead>
            <tbody v-if="table_name=='courses'">
				<tr v-for="(item,index) in table_body_data" :key="index">
                    <td>{{item.id}}</td>
                    <td><router-link class="bold" :to="{ name :'admin.'+table_name+'.detail', params : { id : item.id, agency_id: current_agency, section: 'detail' } }" target="_blank" tag="a">{{ item.name }}</router-link></td>
                    <td>{{item.notes}}</td>
                    <td></td>
					<td></td>
                    <td>
                        <toggle-button
                        class="mt-0 ml-2"
                        :labels="false" :width="50"
                        v-model="item.published"
                        :color="{ checked : green, unchecked : red, disabled : '#CCCCCC' }" :sync="true"
                        @change="toggleOperational(item)"/>
                    </td>
                    <td>
                        <toggle-button
                        class="mt-0 ml-2"
                        :labels="false" :width="50"
                        :color="{ checked : green, unchecked : red, disabled : '#CCCCCC' }" :sync="true"
                        :value= "item.meta_integration_data ? JSON.parse(item.meta_integration_data).non_payable : false"
                        @change="(event) => changeIntegrationData(item, event, 'non_payable')"/>
                    </td>
					<td>
                        <v-select :noDrop= "item.meta_integration_data ? JSON.parse(item.meta_integration_data).non_payable : false"
                        :disabled= "item.meta_integration_data ? JSON.parse(item.meta_integration_data).non_payable : false" 
                        :clearable="false" :options="['Nevvon In-Service', 'Nevvon Alternate', 'None']"
                        :value= "item.meta_integration_data && JSON.parse(item.meta_integration_data).pay_code ? JSON.parse(item.meta_integration_data).pay_code : 'None'"
                        @input="(newVal) => changeIntegrationData(item, {value: newVal}, 'pay_code')">
                        </v-select>
                    </td>
                    <td>
                        <toggle-button
                        class="mt-0 ml-2"
                        :labels="false" :width="50"
                        :color="{ checked : green, unchecked : red, disabled : '#CCCCCC' }" :sync="true"
                        :value= "item.meta_integration_data ? JSON.parse(item.meta_integration_data).delayed_pay : false"
                        @change="(event) => changeIntegrationData(item, event, 'delayed_pay')"/>
                    </td>
                    <table-actions v-on="$listeners" :table_name="table_name" :item="item" ></table-actions>
                </tr>
            </tbody>
            <tbody v-if="table_name=='providers'">
				<tr v-for="(item,index) in table_body_data" :key="index">
                    	<td class="text-center">
                            <router-link tag="a" :to="{ name: 'admin.providers.detail', params : { id : item.id } }" :style="{ 'background-image' : 'url(data:image/jpeg;base64,'+item.image+')' }" class="picture-container thumb-container"></router-link>
                        </td>
                    	<td>{{ item.ssn }}</td>
                        <td>
                            <router-link :to="{ name :'admin.providers.detail', params : { id : item.id }, query : { agency_id: $route.params.id } }" class="medium">{{ item.last_name }} {{ item.first_name }} </router-link>
                        </td>
                        <td>{{ item.email }}</td>
                    <table-actions v-on="$listeners" :table_name="table_name" :item="item" ></table-actions>
                </tr>
            </tbody>
            <tbody v-if="table_name == 'roles_permissions'">
                <tr v-for="(subrole,index) in table_body_data" :key="index">
                        <td>{{ subrole.name }}</td>
                        <td>{{ subrole.email }}</td>
                        <td v-if="subrole.organization_role.length <= 1 ">{{ subrole.organization_role[0].display_name }}</td>
                       
                        <td v-else>  <table-tool-tip :item="subrole" /> </td>
                        <td>	
                        <toggle-button
                            v-model=" subrole.is_active == 1 ? true : false" 
                             @change="toggleOrganizationUser(subrole, index, $event)"
				            :labels="{ checked : 'Active', unchecked : 'Deactivated'}" :width="100"
							:color="{ checked : green, unchecked : red, disabled : '#CCCCCC' }" :sync="true"
						/>
                    </td>
                        <table-actions v-on="$listeners" :table_name="table_name" :item="subrole" ></table-actions>

                </tr>

            </tbody>
            <tbody v-if="table_name == 'discipline' || table_name== 'location'">
                <tr v-for="(item, index) in table_body_data" :key="index">
                    <td>{{ item.name }}
                        <table class="mt-3 table table-bordered" v-if="item.sub_locations">
                                <tbody>
                                <tr v-for="(sub, index) in item.sub_locations" :key="index">
                                    <td class="table-width-fix">{{sub.name}}</td>
                                     <table-actions v-on="$listeners" :table_name="'sub_locations'" :item="sub" :parent_subject="item" @openEditModal="openEditModal"></table-actions>
                                </tr>
                            </tbody>
                        </table>
                    </td>
                    <table-actions v-on="$listeners" :table_name="table_name" :item="item" @openAddModal="openAddModal" ></table-actions>
                </tr>
            </tbody>
            <tbody v-if="table_name == 'languages'">
                <tr v-for="(item, index) in table_body_data" :key="index">
                    <td>{{ item.name }}</td>
                    <td>	
                        <toggle-button v-model=" item.available_in_system ? true : false" 
												:labels="{ checked : 'Active', unchecked : 'Deactivated'}" :width="100"
												:color="{ checked : green, unchecked : red, disabled : '#CCCCCC' }" :sync="true"
                                                @change="toggleLanguageSystemStatus(item, index, $event)"
											/>
                    </td>
                    <td>	
                        <toggle-button v-model=" item.available_for_users ? true : false" 
												:labels="{ checked : 'Active', unchecked : 'Deactivated'}" :width="100"
												:color="{ checked : green, unchecked : red, disabled : '#CCCCCC' }" :sync="true"
                                                @change="toggleLanguageUserStatus(item, index, $event)"
											/>
                    </td>
                   
                </tr>
            </tbody>
         </table>
        </div>
        
        <div class="row" v-if="pagination_section">
            <div class="col-12 col-lg-6">
                Showing {{ table_info.from }} to {{ table_info.to }} of {{ table_info.total || table_info.total_rows }}
            </div><!--col-->
            <div class="col-12 col-lg-6">
                <b-pagination align="right" :total-rows="table_info.total" v-model="table_info.current_page" :per-page="parseInt(table_info.per_page)" @change="setPage">
                 </b-pagination>
            </div><!--col-->
        </div><!--row-->



        <organization-sub-location-add-delete-edit v-if="new_taxonomy_modal"
            :new_taxonomy_modal="new_taxonomy_modal"
            :add_taxonomy_title="add_taxonomy_title"
            :current_taxonomy_field="current_taxonomy_field"
            :parent_subject="parent_subject"
            :delete_option="delete_option"
            :add_option="add_option"
            :item="updated_subject"
            @closeModal="closeModal"
            
        >

        </organization-sub-location-add-delete-edit>
        <!-- <b-modal v-model="new_taxonomy_modal" :title="add_taxonomy_title" ok-title="Submit"
		 @cancel="new_taxonomy_name = ''" @ok="createTaxonomy" :ok-disabled="new_taxonomy_name == ''"
		>
			<form @submit.prevent="createTaxonomy">
				<div class="lightgray-content p-3 rounded mb-2">
					<div class="row">
						<div class="col-12">
							<div class="form-group input-content">
								<label>{{current_taxonomy_field}} name</label>
								<input type="text" v-model="new_taxonomy_name" class="form-control" v-validate="'required'" name="taxonomy_">
								<span class="input-error-msg" v-if="errors.first('taxonomy_')">{{current_taxonomy_field}} is required</span>
							</div>							
						</div>
					</div>
				</div>
			</form>
		</b-modal> -->
        

    </div>
</template>
<script>
import OrganizationSubLocationAddDeleteEdit from '../../admin/organization/shared/OrganizationSubLocationAddDeleteEdit'
import TableToolTip from '../.../../../shared/TableToolTip.vue'

export default {
      props:['table_info','table_headers', 'dataOptions','table_body_data','table_name', 'subrole_type','pagination_section'],
      components:{
          TableToolTip,
          OrganizationSubLocationAddDeleteEdit
      },
    computed:{
		current_agency(){
			return this.$route.params.agency_id
		}
	 },
      data:function(){
          return{
            table_data:'',
            red : this.config.COLORS.RED,
            green : this.config.COLORS.GREEN,
            new_taxonomy_modal:false,
            add_taxonomy_title:'',
            new_taxonomy_name:'',
            current_taxonomy_field: '',
            parent_subject:'',
            delete_option:false,
            add_option: false,
            updated_subject:''
          }
      },
      created(){
      },
  
      methods:{
        closeModal: function(){
            this.new_taxonomy_modal = false
            this.$emit('getLocations')
        },
        openAddModal : function( title, field_name, parent){
            this.add_taxonomy_title = title
            this.current_taxonomy_field = field_name
            this.parent_subject = parent
            this.add_option = true
            this.delete_option = false
            this.new_taxonomy_modal = true
            
        },
        openEditModal : function( item, parent_subject, title, field_name, delete_option){
            this.updated_subject = item
            this.parent_subject = parent_subject
            this.add_taxonomy_title = title
            this.current_taxonomy_field = field_name
            this.add_option = false
            if(delete_option){
                this.delete_option = true
            }
            this.new_taxonomy_modal = true
        },
        toggleLanguageSystemStatus(language, index, event){
            this.$emit('updateLanguageSystem',({language:language, index:index, table:true}))
        },
        toggleLanguageUserStatus(language, index, event){
            var params = {
                    id: language.id,
                    status: (language.available_for_users == 0) ? 'publish' : 'unpublish'
            }
            this.$store.dispatch('SMELanguageAvailabilty', params).then((res)=>{{ 
                language[0] = res.data
                this.$emit('updateLanguageUser',({language:res.data, index:index}))
            }
            }).catch((error) => {
                console.log(error)
                event.value = !event.value
            })

        },
        toggleOperational(item){
            var params = {
               id:item.id,
               organization_id: this.current_agency
            }
            if(item.published){
                this.$store.dispatch('publishCourse',params).then((res)=>{

                })
            }else{
                 this.$store.dispatch('unpublishCourse',params).then((res)=>{

                })

            }
        },
        toggleOrganizationUser(user, index, $event){
            var params = {
               id:user.id,
               organization_id: this.current_agency,
               status: ($event.value) ? 'activate-user' : 'deactivate-user'
            }
            this.$store.dispatch('changeUserStatus',params).then((res)=>{

            }).catch((error) => {
               window.location.reload()
            })

        },
          setPage(page){
               if(this.table_name == 'courses'){
                  this.$emit('setPageCourses',page)
              }
               if(this.table_name == 'providers'){
                  this.$emit('setPageProviders',page)
              }

          },
          changePerPage(page){
              if(this.table_name == 'courses'){
                  this.$emit('changeCoursesPerPage',page)
              }
              if(this.table_name =='providers'){
                   this.$emit('changePerPage',page)
              }
          },
          subroleChecked(subrole_id){
              this.$emit('setSubroleAsDefault',subrole_id)
          },
          changeIntegrationData(item, event, fieldName) {

            const integrationData = item.meta_integration_data

            if (event.value === null) {
                return;
            }

            if (!integrationData && event.value === 'None') {
                return;
            }
            
            if (integrationData) {
                if (fieldName === 'pay_code' && event.value === JSON.parse(integrationData).pay_code) {
                    return;
                }
            }

            //let params = {};

            let params = {
               id: item.id,
               organization_id: this.current_agency,
               meta_integration_data: null
            }

            if (integrationData) {
                params['meta_integration_data'] = {
                    ...JSON.parse(integrationData)
                }
            } else {
                params['meta_integration_data'] = {
                    "pay_code": null,
                    "delayed_pay": false,
                    "non_payable": false
                }
            }

            params['meta_integration_data'][fieldName] = event.value;

            console.log(params);

            this.$store.dispatch('updateIntegrationData', params).then((res)=>{
                this.setPage(this.table_info.current_page);
            })

          }
      }

}
</script>
<style>
.table-width-fix{
    min-width: 150px !important;
}                         
</style>



// WEBPACK FOOTER //
// src/components/shared/profile/AgencyDetailTables.vue